module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-mobile-img-bb06d5fba5ebe59e0298c1753491ad54.png";